import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import PartyEditFormImpl from 'components/party/PartyEditFormImpl';

export default function AddPartyActionImpl(){

    return (
        <>
        <PartyEditFormImpl />
        </>
    )
}